import React from "react";
import partnersimage1 from "../assets/img/logo1.jpg"
import partnersimage2 from "../assets/img/logo2.jpg"
import partnersimage3 from "../assets/img/repc.png"
import partnersimage4 from "../assets/img/logo4.jpg"

export const Affiliations = () => {
  const partnersData = [
    {
      id: 1,
      partnerImg: partnersimage1,
    },
    {
      id: 2,
      partnerImg: partnersimage2,
    },
    {
      id: 3,
      partnerImg: partnersimage3,
    },
    {
      id: 4,
      partnerImg: partnersimage4,
    }
  ];
  return (
    <>
      <div className="partners">
        <div className="partners-container">
          <div className="section-header">
            <h3>Our Affiliations</h3>
            <div className="line-mf"></div>

          </div>

          <div className="partners-area">
            <div className="partners-inner">
              {partnersData.map((partneritem) => (
                <div className="partnerslider-image">
                  <img src={partneritem.partnerImg} alt="Partner Logo" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
